import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import Notification from '@ynap/notification';

const bem = new BEMHelper('ValidatedField');

const propTypes = {
    label: PropTypes.string,
    htmlFor: PropTypes.string,
    error: PropTypes.string,
    help: PropTypes.string,
    errorStyle: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    showErrorNotification: PropTypes.bool,
    notificationType: PropTypes.bool,
    customLabel: PropTypes.shape({
        labelName: PropTypes.string,
        LabelWrap: PropTypes.elementType,
        extraElements: PropTypes.node,
    }),
};

const defaultProps = {
    errorStyle: 'error',
    customLabel: {
        labelName: null,
        LabelWrap: null,
        extraElements: null,
    },
    showErrorNotification: true,
};

export const renderLabel = ({ customLabel, label, htmlFor }) => {
    if (!label && !customLabel?.labelName) return null;

    if (customLabel?.LabelWrap) {
        return (
            <customLabel.LabelWrap {...customLabel.labelWrapProps}>
                <label htmlFor={htmlFor} className={bem('label')}>
                    {customLabel.labelName}
                </label>
                {customLabel.extraElements}
            </customLabel.LabelWrap>
        );
    } else {
        return (
            <label htmlFor={htmlFor} className={bem('label')}>
                {label}
            </label>
        );
    }
};

function ValidatedField(props) {
    const { htmlFor, error, help, errorStyle, className, showErrorNotification, children, notificationType = 'field-error' } = props;

    const childrenWithProps = React.Children.map(children, (child) =>
        typeof child.type !== 'string' ? React.cloneElement(child, { hasError: error }) : child,
    );

    const errorToDisplay = showErrorNotification ? error : null;
    let classNames = [className, errorToDisplay && className ? `${className}--error` : ''];

    return (
        <div className={bem(null, { [htmlFor]: true, error: errorToDisplay }, classNames)}>
            {renderLabel(props)}
            {childrenWithProps}
            {errorToDisplay ? (
                <Notification type={notificationType} message={errorToDisplay} className={bem(errorStyle)} />
            ) : help ? (
                <span className={bem('help')}>{help}</span>
            ) : null}
        </div>
    );
}

ValidatedField.propTypes = propTypes;
ValidatedField.defaultProps = defaultProps;

export default ValidatedField;
